module.exports = __webpack_public_path__ + "img/pakhsh.2090a367.jpg";